import { render, staticRenderFns } from "./CabeceraModalEdicion.vue?vue&type=template&id=406a222f&scoped=true&"
import script from "./CabeceraModalEdicion.vue?vue&type=script&lang=ts&"
export * from "./CabeceraModalEdicion.vue?vue&type=script&lang=ts&"
import style0 from "./CabeceraModalEdicion.vue?vue&type=style&index=0&id=406a222f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406a222f",
  null
  
)

export default component.exports